// Used in assign-review-select-classes.component.html and assignables-list.component.html

// Angular
import {
    Directive,
    EventEmitter,
    HostBinding,
    HostListener,
    Input,
    Output,
    TemplateRef,
    ViewContainerRef,
} from "@angular/core";

/**
 * Code was detailed in stackblitz example demo by shlomoiasssaf in Angular Github
 * source: https://stackblitz.com/edit/angular-material2-issue-qatslc?file=app%2Fcdk-detail-row.directive.ts
 * github issue: https://github.com/angular/material2/issues/6095
 */

@Directive({
    selector: "[cdkDetailRow]",
    standalone: false
})
export class CdkDetailRowDirective {
    private row: any;
    private tRef?: TemplateRef<any>;
    private opened = false;

    @HostBinding("class.expanded")
    get expanded(): boolean {
        return this.opened;
    }

    @Input()
    set cdkDetailRow(value: any) {
        if (value !== this.row) {
            this.row = value;
            // this.render();
        }
    }

    @Input("cdkDetailRowTpl")
    set template(value: TemplateRef<any>) {
        if (value !== this.tRef) {
            this.tRef = value;
        }
    }

    @Output() toggleChange = new EventEmitter<CdkDetailRowDirective>();

    constructor(public vcRef: ViewContainerRef) {}

    @HostListener("click")
    onClick(): void {
        this.toggle();
    }

    toggle(): void {
        if (this.opened) {
            this.vcRef.clear();
        } else {
            this.render();
        }
        this.opened = this.vcRef.length > 0;
        this.toggleChange.emit(this);
    }

    private render(): void {
        this.vcRef.clear();
        if (this.tRef && this.row) {
            this.vcRef.createEmbeddedView(this.tRef, { $implicit: this.row });
        }
    }

    toggleNoEmit(): void {
        if (this.opened) {
            this.vcRef.clear();
        } else {
            this.render();
        }
        this.opened = this.vcRef.length > 0;
    }
}
